import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import RiskReportCard from '../RiskReportCard/RiskReportCard';
import { PDFReportIcon } from 'on_web/assets/iconsList';

import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { useTranslation } from 'react-i18next';

export default function RiskReport(props) {
  const { report } = props;

  const [isDesktop] = useCheckScreenSize();
  const { t } = useTranslation();

  return (
    <Box
      style={{
        marginBottom: isDesktop ? '0' : '55px',
      }}
    >
      <RiskReportCard
        icon={<PDFReportIcon height={60} />}
        title={t('reporting.myAssessment.riskReportTitle')}
        downloadText={t('reporting.myAssessment.downloadPDFText')}
        generatingText={t('reporting.myAssessment.generatingPDFText')}
        buttonText={t('reporting.myAssessment.download')}
        downloadUrl={report && report.download_url ? report.download_url : null}
        isDesktop={isDesktop}
      />
    </Box>
  );
}

RiskReport.propTypes = {
  report: PropTypes.shape({
    download_url: PropTypes.string,
    is_available: PropTypes.bool,
    language: PropTypes.string,
    report_code: PropTypes.string,
    report_name: PropTypes.string,
  }),
};
